import Api from "../api";
let uri = '/api/ed/metodologia';

export const getMetodologias = () => {
    return Api.getInstance().executeGetQuery(`${uri}`)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

export const adminMetodologias = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}



